import { useChainData } from "@sablier/v2-hooks";
import { _ } from "@sablier/v2-mixins";
import { IChain } from "@sablier/v2-types";
import { useSwitchNetwork } from "wagmi";
import useAccount from "./useAccount";

/** Get the local chain definition for the connected chain id (from provider) or for the arbitrary id parameter */

export default function useChain(): {
  chain: IChain | undefined;
  id: number | undefined;
  switchTo: ReturnType<typeof useSwitchNetwork>["switchNetworkAsync"];
} {
  const { chainId } = useAccount();
  const { switchNetworkAsync: switchTo } = useSwitchNetwork();

  const { chain } = useChainData(chainId);

  return {
    id: chainId,
    chain,
    switchTo,
  };
}
